// extracted by mini-css-extract-plugin
export default {"taskOptions":"styles_taskOptions__2WHkn","optionsTitle":"styles_optionsTitle__NCHpS","taskOptionsPopover":"styles_taskOptionsPopover__qhKgl"};